import initializeComponent from '../Shared/react-initialize';
import { ProductNote } from '@ifixit/product-page-components';

initializeComponent('ProductNote', ProductNote);
